import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';

const API = 'https://centrocomunicar.com/api-comunicar/endpoints/secciones_admin.php';

const IconGrip    = () => <svg viewBox="0 0 20 20" fill="currentColor" width="16" height="16"><path d="M7 4a1 1 0 100 2 1 1 0 000-2zM7 9a1 1 0 100 2 1 1 0 000-2zM7 14a1 1 0 100 2 1 1 0 000-2zM13 4a1 1 0 100 2 1 1 0 000-2zM13 9a1 1 0 100 2 1 1 0 000-2zM13 14a1 1 0 100 2 1 1 0 000-2z"/></svg>;
const IconEye     = () => <svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="currentColor" strokeWidth="2"/><circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2"/></svg>;
const IconEyeOff  = () => <svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><line x1="1" y1="1" x2="23" y2="23" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>;
const IconEdit    = () => <svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>;
const IconCheck   = () => <svg viewBox="0 0 24 24" fill="none" width="15" height="15"><polyline points="20 6 9 17 4 12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>;
const IconUp      = () => <svg viewBox="0 0 24 24" fill="none" width="15" height="15"><polyline points="18 15 12 9 6 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>;
const IconDown    = () => <svg viewBox="0 0 24 24" fill="none" width="15" height="15"><polyline points="6 9 12 15 18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>;

const token = () => localStorage.getItem('com_admin_token') || '';

export default function AdminSecciones() {
  const [tab,      setTab]      = useState('cursos');
  const [secciones,setSecciones]= useState([]);
  const [loading,  setLoading]  = useState(true);
  const [editId,   setEditId]   = useState(null);
  const [editForm, setEditForm] = useState({ titulo:'', subtitulo:'' });
  const [saving,   setSaving]   = useState(false);
  const [saved,    setSaved]    = useState(null);

  const fetchSecciones = useCallback(async (pagina) => {
    setLoading(true);
    const r = await fetch(`${API}?action=list&pagina=${pagina}`);
    const j = await r.json();
    if (j.success) setSecciones(j.data);
    setLoading(false);
  }, []);

  useEffect(() => { fetchSecciones(tab); }, [tab, fetchSecciones]);

  const toggleVisible = async (sec) => {
    const updated = { ...sec, visible: sec.visible ? 0 : 1 };
    await fetch(`${API}?action=update`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` },
      body: JSON.stringify(updated),
    });
    setSecciones(prev => prev.map(s => s.id === sec.id ? updated : s));
  };

  const moverSeccion = async (idx, dir) => {
    const arr = [...secciones];
    const swap = idx + dir;
    if (swap < 0 || swap >= arr.length) return;
    [arr[idx], arr[swap]] = [arr[swap], arr[idx]];
    const items = arr.map((s, i) => ({ id: s.id, orden: i + 1 }));
    setSecciones(arr.map((s, i) => ({ ...s, orden: i + 1 })));
    await fetch(`${API}?action=reorder`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` },
      body: JSON.stringify({ items }),
    });
  };

  const startEdit = (sec) => {
    setEditId(sec.id);
    setEditForm({ titulo: sec.titulo, subtitulo: sec.subtitulo || '' });
  };

  const saveEdit = async (sec) => {
    setSaving(true);
    await fetch(`${API}?action=update`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` },
      body: JSON.stringify({ ...sec, ...editForm }),
    });
    setSecciones(prev => prev.map(s => s.id === sec.id ? { ...s, ...editForm } : s));
    setEditId(null);
    setSaving(false);
    setSaved(sec.id);
    setTimeout(() => setSaved(null), 2000);
  };

  return (
    <div style={{ padding: '2rem', fontFamily: '"DM Sans", sans-serif', maxWidth: 860, margin: '0 auto' }}>

      {/* Header */}
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:'1.5rem' }}>
        <div>
          <h1 style={{ fontSize:'1.5rem', fontWeight:700, color:'#111614', margin:0 }}>Secciones de páginas</h1>
          <p style={{ margin:'.3rem 0 0', color:'#5a6a63', fontSize:'.88rem' }}>Edita el título, subtítulo, visibilidad y orden de cada sección.</p>
        </div>
        <div style={{ display:'flex', gap:'.5rem' }}>
          <Link to="/admin/cursos" style={{ fontSize:'.82rem', color:'#14736C', fontWeight:600 }}>← Volver al admin</Link>
        </div>
      </div>

      {/* Tabs */}
      <div style={{ display:'flex', gap:'.5rem', marginBottom:'1.5rem' }}>
        {['cursos','materiales'].map(t => (
          <button key={t} onClick={() => setTab(t)} style={{
            padding:'.5rem 1.2rem', borderRadius:100, border:'1.5px solid',
            borderColor: tab===t ? '#14736C' : 'rgba(139,202,175,.3)',
            background: tab===t ? '#032D29' : '#fff',
            color: tab===t ? '#8BCAAF' : '#5a6a63',
            fontWeight:700, fontSize:'.85rem', cursor:'pointer', fontFamily:'inherit',
            textTransform:'capitalize'
          }}>
            {t === 'cursos' ? '📚 Cursos' : '🗂 Materiales'}
          </button>
        ))}
      </div>

      {/* Lista */}
      {loading ? (
        <p style={{ color:'#5a6a63', fontSize:'.9rem' }}>Cargando…</p>
      ) : (
        <div style={{ display:'flex', flexDirection:'column', gap:'.75rem' }}>
          {secciones.map((sec, idx) => (
            <div key={sec.id} style={{
              background:'#fff', borderRadius:14,
              border: `1.5px solid ${sec.visible ? 'rgba(139,202,175,.25)' : 'rgba(200,200,200,.3)'}`,
              padding:'1rem 1.2rem',
              opacity: sec.visible ? 1 : 0.55,
              transition:'all .2s',
              boxShadow:'0 2px 8px rgba(0,0,0,.04)'
            }}>
              <div style={{ display:'flex', alignItems:'flex-start', gap:'1rem' }}>

                {/* Grip + orden */}
                <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:'.2rem', paddingTop:'.2rem' }}>
                  <button onClick={() => moverSeccion(idx,-1)} disabled={idx===0}
                    style={{ background:'none', border:'none', cursor:'pointer', color: idx===0?'#ccc':'#5a6a63', padding:'.1rem' }}>
                    <IconUp/>
                  </button>
                  <span style={{ color:'#9ca3af', fontSize:'.72rem', fontWeight:700 }}>{idx+1}</span>
                  <button onClick={() => moverSeccion(idx,1)} disabled={idx===secciones.length-1}
                    style={{ background:'none', border:'none', cursor:'pointer', color: idx===secciones.length-1?'#ccc':'#5a6a63', padding:'.1rem' }}>
                    <IconDown/>
                  </button>
                </div>

                {/* Contenido */}
                <div style={{ flex:1 }}>
                  {editId === sec.id ? (
                    <div style={{ display:'flex', flexDirection:'column', gap:'.6rem' }}>
                      <input
                        value={editForm.titulo}
                        onChange={e => setEditForm(f => ({...f, titulo:e.target.value}))}
                        placeholder="Título de la sección"
                        style={{ padding:'.55rem .9rem', borderRadius:10, border:'1.5px solid rgba(139,202,175,.4)', fontFamily:'inherit', fontSize:'.9rem', fontWeight:700, color:'#111614', outline:'none' }}
                      />
                      <input
                        value={editForm.subtitulo}
                        onChange={e => setEditForm(f => ({...f, subtitulo:e.target.value}))}
                        placeholder="Subtítulo (descripción breve)"
                        style={{ padding:'.55rem .9rem', borderRadius:10, border:'1.5px solid rgba(139,202,175,.3)', fontFamily:'inherit', fontSize:'.85rem', color:'#5a6a63', outline:'none' }}
                      />
                      <div style={{ display:'flex', gap:'.5rem' }}>
                        <button onClick={() => saveEdit(sec)} disabled={saving}
                          style={{ display:'flex', alignItems:'center', gap:'.35rem', background:'#032D29', color:'#8BCAAF', border:'none', borderRadius:100, padding:'.45rem 1rem', fontWeight:700, fontSize:'.82rem', cursor:'pointer', fontFamily:'inherit' }}>
                          <IconCheck/> Guardar
                        </button>
                        <button onClick={() => setEditId(null)}
                          style={{ background:'none', border:'1.5px solid rgba(139,202,175,.3)', borderRadius:100, padding:'.45rem 1rem', fontWeight:600, fontSize:'.82rem', cursor:'pointer', color:'#5a6a63', fontFamily:'inherit' }}>
                          Cancelar
                        </button>
                      </div>
                    </div>
                  ) : (
                    <>
                      <div style={{ display:'flex', alignItems:'center', gap:'.6rem', marginBottom:'.2rem' }}>
                        <strong style={{ fontSize:'.95rem', color:'#111614' }}>{sec.titulo}</strong>
                        <span style={{ fontSize:'.7rem', background:'#f3f8f5', color:'#5a6a63', borderRadius:6, padding:'1px 8px', fontWeight:600 }}>{sec.clave}</span>
                        {saved === sec.id && <span style={{ fontSize:'.72rem', color:'#14736C', fontWeight:700 }}>✓ Guardado</span>}
                      </div>
                      {sec.subtitulo && <p style={{ margin:0, fontSize:'.82rem', color:'#5a6a63', lineHeight:1.5 }}>{sec.subtitulo}</p>}
                    </>
                  )}
                </div>

                {/* Acciones */}
                {editId !== sec.id && (
                  <div style={{ display:'flex', gap:'.4rem', flexShrink:0 }}>
                    <button onClick={() => startEdit(sec)} title="Editar"
                      style={{ background:'#f3f8f5', border:'1.5px solid rgba(139,202,175,.3)', borderRadius:8, padding:'.45rem .6rem', cursor:'pointer', color:'#14736C', display:'flex', alignItems:'center' }}>
                      <IconEdit/>
                    </button>
                    <button onClick={() => toggleVisible(sec)} title={sec.visible ? 'Ocultar sección' : 'Mostrar sección'}
                      style={{ background: sec.visible ? '#edfaf4' : '#f3f4f6', border:'1.5px solid', borderColor: sec.visible?'rgba(139,202,175,.4)':'rgba(200,200,200,.4)', borderRadius:8, padding:'.45rem .6rem', cursor:'pointer', color: sec.visible?'#14736C':'#9ca3af', display:'flex', alignItems:'center' }}>
                      {sec.visible ? <IconEye/> : <IconEyeOff/>}
                    </button>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}